/**
 * @file UnknownDomainsSheet.tsx
 * @description Шторка «Неизвестные домены за 7 дней» на экране «Магазины»
 * (phase19.28 этап А; uiux-platform-shops §2, §5): справа на широком
 * экране, снизу во весь экран на телефоне. Строка → «Привязать к магазину…».
 */

import { useState } from "react";

import type { ShopListItem, UnknownDomain } from "../../../lib/api-platform-shops";
import { PHONE_QUERY, useMediaQuery } from "../../../hooks/useMediaQuery";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "../../ui/sheet";
import { BindDomainDialog } from "./BindDomainDialog";
import { UnknownDomainsList } from "./UnknownDomainsList";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  items: UnknownDomain[];
  loading: boolean;
  error: string | null;
  onRetry: () => void;
  shops: ShopListItem[];
  /** Привязали адрес — экран перечитывает список магазинов и журнал. */
  onBound: () => void;
}

export function UnknownDomainsSheet({ open, onOpenChange, items, loading, error, onRetry, shops, onBound }: Props) {
  const phone = useMediaQuery(PHONE_QUERY);
  const [binding, setBinding] = useState<UnknownDomain | null>(null);

  return (
    <>
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent
          side={phone ? "bottom" : "right"}
          className={phone ? "h-full overflow-y-auto" : "w-full max-w-md overflow-y-auto"}
        >
          <SheetHeader>
            <SheetTitle>Неизвестные домены за 7 дней</SheetTitle>
            <SheetDescription>На эти адреса приходили запросы, но они не привязаны ни к одному магазину.</SheetDescription>
          </SheetHeader>
          <UnknownDomainsList
            items={items}
            loading={loading}
            error={error}
            onRetry={onRetry}
            bindLabel="Привязать к магазину…"
            onBind={setBinding}
          />
        </SheetContent>
      </Sheet>
      <BindDomainDialog
        item={binding}
        shops={shops}
        onClose={() => setBinding(null)}
        onBound={() => {
          setBinding(null);
          onBound();
        }}
      />
    </>
  );
}
